export { connect } from './connect';
export { InjectNatsClient, NATS_CONNECTION, NatsModule } from './NatsModule';
export * from './service';
